import { Button, Flex, IconButton, ListItem, Text } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import UserAvatar from "../UserAvatar";
import colors from "utils/colors";

export const ContactRow = ({
  contact,
  editable,
  removeMember,
  userType,
}: {
  contact: any;
  editable?: boolean;
  removeMember?: (id: string) => void;
  userType?: string;
}) => {
  return (
    <ListItem
      _last={{
        borderBottomWidth: "0px",
        pb: "0px",
      }}
      borderBottomColor="gray.50"
      borderBottomWidth="1px"
      py="16px"
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Flex alignItems="center">
          <UserAvatar size="50px" mr="14px" user={contact.user} />
          <Flex flexDir="column">
            <Text
              color="#171B1E"
              fontWeight="600"
              fontSize="15px"
              lineHeight="22px"
            >
              {contact.user?.first_name} {contact.user?.last_name}
            </Text>
            <Flex flexDir="column" fontSize="13px" color="gray.600">
              {contact.user?.role?.name && (
                <Text color="primary">{contact.user.role.name}</Text>
              )}
              {contact.user?.job_title && (
                <Text>{contact.user.job_title}</Text>
              )}
            </Flex>
          </Flex>
        </Flex>
        {userType === "borrower" && (
          <Link to={`/messages/?user=${contact.user.id}`}>
            <IconButton
              w="40px"
              h="40px"
              background="gray.50"
              borderWidth="0px"
              borderRadius="50%"
              aria-label="message-contact"
              icon={
                <FontAwesomeIcon
                  color={colors.PRIMARY}
                  icon={["fas", "message"]}
                />
              }
            />
          </Link>
        )}
        {editable && removeMember && (
          <Button
            onClick={() => removeMember(contact.id)}
            color="primary"
            variant="ghost"
            px="0px"
            size="sm"
          >
            Remove
          </Button>
        )}
      </Flex>
    </ListItem>
  );
};
